"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getSchemas;
    }
});
const _schemas = require("./templates/schemas");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getSchemas(context, { base, columns, views, tableName }, _ncMeta = _Noco.default.ncMeta) {
    const swaggerSchemas = (0, _schemas.getModelSchemas)({
        tableName,
        orgs: 'v1',
        baseName: base.title,
        columns
    });
    for (const { view, columns: viewColumns } of views){
        const swaggerColumns = columns.filter((c)=>{
            var _viewColumns_find;
            return (_viewColumns_find = viewColumns.find((vc)=>vc.fk_column_id === c.column.id)) == null ? void 0 : _viewColumns_find.show;
        });
        Object.assign(swaggerSchemas, (0, _schemas.getViewSchemas)({
            tableName,
            viewName: view.title,
            orgs: 'v1',
            columns: swaggerColumns,
            baseName: base.title
        }));
    }
    return swaggerSchemas;
}
